module.exports = __webpack_public_path__ + "static/nature-588affa238a1d6dda09d17fe42d4707d.jpg";